import Menu from './Menu'
import Section from './Section'

const Distributions = {
  Menu,
  Section
}

export default Distributions
